export function Crosshair({ className = "" }) {
  return (
    <span
      aria-hidden
      className={`pointer-events-none absolute z-10 select-none font-tech text-molten ${className}`}
    >
      +
    </span>
  );
}

export function TechLabel({ children, className = "" }) {
  return (
    <span
      className={`font-tech text-[10px] uppercase tracking-[0.3em] text-white/40 ${className}`}
    >
      {children}
    </span>
  );
}
